// @ts-ignore
import Plane from 'pixi.js/lib/mesh/Plane';

const VERSION = '4.8.9';

if (PIXI.VERSION !== VERSION) {
    console.warn(`PIXI NineSlicePlane was extended with pixi version ${VERSION} and may have bugs in current ${PIXI.VERSION} version`);
}

// @ts-ignore
const refresh = PIXI.mesh.NineSlicePlane.prototype._refresh;

// @ts-ignore
PIXI.mesh.NineSlicePlane.prototype._refresh = function _refresh() {
    if (!this.texture.trim) {
        refresh.call(this);
        return;
    }

    Plane.prototype._refresh.call(this);

    const uvs = this.uvs;
    const texture = this._texture;
    const trim = this.texture.trim;
    const scX = this._width / this.texture.width;
    const scY = this._height / this.texture.height;

    this._origWidth = texture.orig.width;
    this._origHeight = texture.orig.height;

    uvs[0] = uvs[8] = uvs[16] = uvs[24] = trim.left / texture.width;
    uvs[1] = uvs[3] = uvs[5] = uvs[7] = trim.top / texture.height;
    uvs[6] = uvs[14] = uvs[22] = uvs[30] = trim.right / texture.width;
    uvs[25] = uvs[27] = uvs[29] = uvs[31] = trim.bottom / texture.height;

    uvs[2] = uvs[10] = uvs[18] = uvs[26] = (trim.left * scX + this._leftWidth * scX) / this._width;
    uvs[4] = uvs[12] = uvs[20] = uvs[28] = (trim.right * scX - this._rightWidth * scX) / this._width;
    uvs[9] = uvs[11] = uvs[13] = uvs[15] = (trim.top * scY + this._topHeight * scY) / this._height;
    uvs[17] = uvs[19] = uvs[21] = uvs[23] = (trim.bottom * scY - this._bottomHeight * scY) / this._height;

    const vertices = this.vertices;
    const w = this._leftWidth + this._rightWidth;
    const h = this._topHeight + this._bottomHeight;
    const scaleX = this._width > w ? 1.0 : this._width / w;
    const scaleY = this._height > h ? 1.0 : this._height / h;

    const x0 = trim.left * scaleX;
    const x1 = (trim.left + this._leftWidth) * scaleX;
    const x2 = this._width - (this.texture.width - trim.right + this._rightWidth) * scaleX;
    const x3 = this._width - (this.texture.width - trim.right) * scaleX;

    const y0 = trim.top * scaleY;
    const y1 = (trim.top + this._topHeight) * scaleY;
    const y2 = this._height - (this.texture.height - trim.bottom + this._bottomHeight) * scaleY;
    const y3 = this._height - (this.texture.height - trim.bottom) * scaleY;

    vertices[0] = vertices[8] = vertices[16] = vertices[24] = x0;
    vertices[2] = vertices[10] = vertices[18] = vertices[26] = x1;
    vertices[4] = vertices[12] = vertices[20] = vertices[28] = x2;
    vertices[6] = vertices[14] = vertices[22] = vertices[30] = x3;

    vertices[1] = vertices[3] = vertices[5] = vertices[7] = y0;
    vertices[9] = vertices[11] = vertices[13] = vertices[15] = y1;
    vertices[17] = vertices[19] = vertices[21] = vertices[23] = y2;
    vertices[25] = vertices[27] = vertices[29] = vertices[31] = y3;

    this.dirty++;

    this.multiplyUvs();
};
